import styled from 'vue-styled-components';

const titleProps = {
	size: {
		type: String,
		default: null,
	},
	color: {
		type: String,
		default: null,
	},
	center: {
		type: Boolean,
		default: false,
	},
	fontFamily: {
		type: String,
		default: 'inherit',
	},
};

const H1 = styled('h1', titleProps)`
  margin-bottom: 1.5rem;
  font-family: ${props => props.fontFamily};
  text-align: ${props => (props.center ? 'center' : 'left')};
	color: ${props => props.color};
	@media screen and (min-width: 60rem) {
		font-size: ${props => (props.size ? props.size : '2.25rem')};
	}
`;

const H2 = styled('h2', titleProps)`
	color: ${props => (props.color ? props.color : props.theme.primaryColor)};
	font-family: ${props => props.fontFamily};
	font-size: ${props => (props.size ? props.size : '1.25rem')};
	text-align: ${props => (props.center ? 'center' : 'left')};
	line-height: 1.2;
	margin-bottom: 0.75rem;
`;

export { H1, H2 };
